const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.02 100.803L67.8121 14.3859C66.5172 11.8118 63.8819 10.1875 61.0005 10.1875C58.119 10.1875 55.4837 11.8118 54.1888 14.3859L10.9805 100.803C9.7701 103.162 9.8819 105.983 11.2752 108.239C12.6685 110.495 15.1404 111.859 17.7921 111.833H104.209C106.861 111.859 109.332 110.495 110.726 108.239C112.119 105.983 112.231 103.162 111.02 100.803ZM57.188 91.5C57.1889 90.4892 57.5911 89.5202 58.3063 88.8059C58.6589 88.4613 59.0726 88.1854 59.5263 87.9925C60.4669 87.5854 61.534 87.5854 62.4746 87.9925C62.9283 88.1854 63.3421 88.4613 63.6946 88.8059C64.7992 89.8948 65.1221 91.5499 64.508 92.9742C64.1262 93.8945 63.3949 94.6258 62.4746 95.0075C62.0097 95.2103 61.5077 95.3141 61.0005 95.3125C60.4937 95.3099 59.9925 95.2062 59.5263 95.0075C59.0726 94.8146 58.6589 94.5388 58.3063 94.1942C57.9445 93.8559 57.6661 93.4383 57.493 92.9742C57.2943 92.508 57.1906 92.0068 57.188 91.5ZM61.0005 80.0625C63.106 80.0625 64.813 78.3556 64.813 76.25V45.75C64.813 43.6444 63.106 41.9375 61.0005 41.9375C58.8949 41.9375 57.188 43.6444 57.188 45.75V76.25C57.188 78.3556 58.8949 80.0625 61.0005 80.0625Z",
  fill: "#FC7D20"
});

const SvgBigWarning = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBigWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/big-warning.0f589465.svg";
export { ForwardRef as ReactComponent };